export default "__VITE_ASSET__DvIfT2Ce__"